import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {userGroupApi, UserGroupsFilterQuery} from "../api/userGroupApi"
import {WSUserGroup} from "../types/WebSocketTypes"
import {UserGroupResponse, UserGroupsResponse} from "../models/response"
import {UsersFilter} from "./userReducer"
import {UsersFilterQuery} from "../api/userApi"

export type UserGroupsFilter = {
    limit: number
    offset: number
    status?: "-1" | "0" | "1"
}

type InitialStateType = {
    userGroups: null | UserGroupsResponse
    userGroup: null | UserGroupResponse
    filter: UserGroupsFilter & UserGroupsFilterQuery
    sideFilter: UsersFilter & UsersFilterQuery
    ws: WSUserGroup | null
}

const initialState: InitialStateType = {
    userGroups: null,
    userGroup: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    sideFilter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const userGroupReducer = createSlice({
    name: 'userGroupReducer',
    initialState,
    reducers: {
        setUserGroups(state, {payload}) {
            state.userGroups = payload
        },
        setUserGroup(state, {payload}) {
            state.userGroup = payload
        },
        addUserGroup(state, {payload}) {
            if (state.userGroups) {
                state.userGroups = {
                    total: state.userGroups.total += 1,
                    data: [payload, ...state.userGroups.data],
                }
            }
        },
        editUserGroup(state, {payload}: PayloadAction<UserGroupResponse>) {
            let index = state.userGroups?.data.findIndex(i => i.id === payload.id)
            if (index !== undefined && state.userGroups) state.userGroups.data[index] = payload
            if (state.userGroup) state.userGroup = payload
        },
        setUserGroupsFilter(state, {payload}) {
            state.filter = payload
        },
        setUserGroupSideFilter(state, {payload}) {
            state.sideFilter = payload
        },
        setWSUserGroup(state, {payload}: PayloadAction<WSUserGroup | null>) {
            state.ws = payload
        },
    },
})

export const {setUserGroups, setUserGroup, addUserGroup, editUserGroup, setUserGroupsFilter, setUserGroupSideFilter, setWSUserGroup} = userGroupReducer.actions

export default userGroupReducer.reducer

export const getUserGroups = asyncCreator
('userGroupReducer/getUserGroups', userGroupApi.getUserGroups, setUserGroups)

export const getUserGroup = asyncCreator
('userGroupReducer/getUserGroup', userGroupApi.getUserGroup, setUserGroup)

export const createUserGroup = asyncCreator
('userGroupReducer/createUserGroup', userGroupApi.createUserGroup, addUserGroup)

export const changeUserGroup = asyncCreator
('userGroupReducer/changeUserGroup', userGroupApi.changeUserGroup, editUserGroup)

export const deleteUserGroup = asyncCreator
('userGroupReducer/deleteUserGroup', userGroupApi.deleteUserGroup)